
/* eslint vue/no-mutating-props: 0 */
import { mapState } from 'vuex';
import IconAsbestos from '~/components/icon/IconAsbestos.vue';
import IconExclamationTriangle from '~/components/icon/IconExclamationTriangle.vue';
import IconOil from '~/components/icon/IconOil.vue';
import IconPlasterboard from '~/components/icon/IconPlasterboard.vue';
import IconSoil from '~/components/icon/IconSoil.vue';
import IconTyre from '~/components/icon/IconTyre.vue';

const icons = {
    IconAsbestos,
    IconExclamationTriangle,
    IconOil,
    IconPlasterboard,
    IconSoil,
    IconTyre,
};

export default {
    name: 'BusinessServicesForm',
    props: {
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    async fetch() {
        await this.$store.dispatch('categories/getJobCategories');
    },
    computed: {
        ...mapState(['auth']),
        categories() {
            const categories = [];
            this.$store.state.categories.job.data.forEach((checkCategory) => {
                const category = { ...checkCategory };
                category.icon = icons[category.icon];
                categories.push(category);
            });
            return categories;
        },
    },
    methods: {
        submit() {
            if (this.form.validateFields(['services', 'categories'])) {
                this.$emit('submit');
            }
        },
    },
};
